import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { TelegramProvider } from './context/TelegramContext';
import { initTelegram } from './services/telegram';
import { initialSync } from './db/sync-queue';
import { initSnapshotPolling } from './services/snapshot';
import './i18n';
import '@fontsource-variable/manrope';
import './styles/global.css';
// Дизайны импортируются ПОСЛЕ global.css: их правила должны побеждать в каскаде
import './styles/designs/air.css';
import './styles/designs/glass.css';
import './styles/designs/aurora.css';
import './styles/designs/neo.css';
import './styles/designs/ukraine.css';
import './styles/designs/leaf.css';
import './styles/designs/vyshyvanka.css';

try {
  initTelegram();
} catch (e) {
  console.error('[Barter] Failed to init Telegram:', e);
}

// Данные живут локально: первая загрузка снапшота + отправка очереди записей,
// дальше — опрос версии meta.json (раз в 10 минут, при возврате сети/фокуса).
initialSync().catch(() => {});
initSnapshotPolling();

// autoUpdate-воркер меняет контроллера в фоне, но уже загруженная страница
// продолжает работать старым кодом против новых данных. Перезагружаемся один
// раз при смене контроллера, чтобы телефон не застревал на устаревшей сборке.
if ('serviceWorker' in navigator) {
  let reloadedOnControllerChange = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadedOnControllerChange) return;
    reloadedOnControllerChange = true;
    try {
      window.location.reload();
    } catch {
      /* перезагрузка недоступна — обновимся при следующем открытии */
    }
  });
}

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <TelegramProvider>
            <App />
          </TelegramProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
